function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import TabsItem from './item';
import Text from '../text';

var isArray = function isArray(arg) {
  return _typeof(arg) === 'object' && 'map' in arg;
}; // accessibility


var a11y = {
  role: 'tablist'
};

var Tabs = function Tabs(_ref) {
  var activeIndex = _ref.activeIndex,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      forceControl = _ref.forceControl,
      onClick = _ref.onClick,
      others = _objectWithoutProperties(_ref, ["activeIndex", "children", "className", "disabled", "forceControl", "onClick"]);

  var _useState = useState(activeIndex),
      _useState2 = _slicedToArray(_useState, 2),
      _activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  if (!isArray(children)) {
    return children;
  }

  var isActive = function isActive(index, childPropsActive) {
    if (typeof childPropsActive !== 'undefined' && !_activeIndex) return childPropsActive;
    if (index === _activeIndex) return true;
  };

  var toggleActive = function toggleActive(e, index) {
    if (disabled) return false;
    setActiveIndex(index);
    e.target.activeIndex = index;
    if (typeof onClick === 'function') onClick(e);
  };

  return React.createElement("div", _extends({
    className: classNames('tabs', className)
  }, others), React.createElement("ul", a11y, map(children, function (child, index) {
    var props = {
      active: forceControl ? child.props.active : isActive(index, child.props.active),
      key: index,
      tabIndex: index,
      onClick: function onClick(e) {
        return !forceControl ? toggleActive(e, index) : child.props.onClick && child.props.onClick(e);
      }
    };
    return typeof child.valueOf() === 'string' ? React.createElement(TabsItem, props, React.createElement(Tabs.Text, {
      content: child
    })) : React.cloneElement(child, props);
  })));
};

Tabs.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  forceControl: PropTypes.bool,
  activeIndex: PropTypes.number
};
Tabs.Item = TabsItem;
Tabs.Text = Text;
export default withModifiers(Tabs);